<template>
  <nuxt-link
    class="flex items-center justify-center px-1.5 py-3 text-base leading-[19px] hover:bg-lightGray xs:px-[10px] sm:px-[15px] md:px-[25px]"
    :class="isActive ? 'font-bold' : 'font-light'"
    :to="paginationLinkTo(page)"
    @click="scrollToTop"
  >
    <slot />
  </nuxt-link>
</template>

<script setup lang="ts">
type PaginationButtonProps = {
  disabled?: boolean
  isActive?: boolean
  page: number
}

withDefaults(defineProps<PaginationButtonProps>(), {
  disabled: false,
  isActive: false,
})

const { paginationLinkTo } = useRouteHelpers()

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
</script>
